export default "__VITE_ASSET__827f4fa5__"